(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vzy-bf-copy"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vzy-bf-copy')){
  customElements.define('vzy-bf-copy',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      this.querySelector('button')?.addEventListener('click',async(event)=>{
        const button=event.currentTarget,label=button.querySelector('[data-copy-label]'),status=this.querySelector('[role="status"]');
        if(this.busy)return;this.busy=true;
        try{await navigator.clipboard.writeText(button.dataset.code);label.textContent='Copiat ✓';status.textContent='Codul '+button.dataset.code+' a fost copiat.';}
        catch{label.textContent='Selectează codul';status.textContent='Copierea nu a reușit. Folosește codul '+button.dataset.code+'.';}
        finally{this.busy=false;}
      },{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vzy-bf-hero"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vzy-bf-hero')){
  customElements.define('vzy-bf-hero',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      this.querySelector('[data-bf-code]')?.addEventListener('click',async(event)=>{
        const button=event.currentTarget,status=this.querySelector('[data-bf-status]');
        try{await navigator.clipboard.writeText(button.dataset.bfCode);status.textContent=button.dataset.bfCopied;this.querySelector('.vzy-bf__ticket-copy>span').textContent=button.dataset.bfCopied}
        catch{status.textContent=button.dataset.bfError;this.querySelector('.vzy-bf__ticket-copy>span').textContent=button.dataset.bfError}
      },{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort()}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vzy-bf-rolling"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vzy-bf-roll'))customElements.define('vzy-bf-roll',class extends HTMLElement{
  connectedCallback(){
    this.disconnect();this.abort=new AbortController();this.media=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.finished=false;
    const sync=()=>this.sync();this.media.addEventListener('change',sync,{signal:this.abort.signal});document.addEventListener('visibilitychange',sync,{signal:this.abort.signal});
    this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);this.sync();
  }
  sync(){
    if(!this.abort||this.abort.signal.aborted)return;
    if(this.media.matches){this.cancelAnimation();this.resetRail();this.dataset.motionState='reduced';return;}
    if(this.finished){this.dataset.motionState='complete';return;}
    const rail=this.querySelector('.vzy-bf-roll__rail');
    if(!rail||typeof rail.animate!=='function'){this.dataset.motionState='static';return;}
    if(!this.visible||document.hidden){this.animation?.pause();rail.style.removeProperty('will-change');this.dataset.motionState=this.animation?'paused':'static';return;}
    if(!this.animation){
      const animation=rail.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(0,-50%,0)'}],{duration:600,delay:2800,easing:'cubic-bezier(0.65,0,0.35,1)',iterations:1,fill:'both'});
      animation.pause();this.animation=animation;
      animation.onfinish=()=>{if(this.animation!==animation)return;this.finished=true;rail.style.removeProperty('will-change');this.dataset.motionState='complete';};
    }
    rail.style.setProperty('will-change','transform');this.animation.play();this.dataset.motionState='running';
  }
  cancelAnimation(){if(this.animation){this.animation.onfinish=null;this.animation.cancel();this.animation=null;}}
  resetRail(){const rail=this.querySelector('.vzy-bf-roll__rail');if(!rail)return;rail.style.removeProperty('transform');rail.style.removeProperty('will-change');}
  disconnect(){this.abort?.abort();this.observer?.disconnect();this.cancelAnimation();this.resetRail();this.finished=false;this.visible=false;this.dataset.motionState='static';}
  disconnectedCallback(){this.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vzy-bf-typewriter"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vzy-bf-typewriter'))customElements.define('vzy-bf-typewriter',class extends HTMLElement{
  connectedCallback(){
    this.disconnect();this.abort=new AbortController();this.media=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.running=false;this.finished=false;
    const sync=()=>this.sync();this.media.addEventListener('change',sync,{signal:this.abort.signal});document.addEventListener('visibilitychange',sync,{signal:this.abort.signal});window.addEventListener('load',sync,{once:true,signal:this.abort.signal});
    this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);this.sync();
  }
  sync(){
    if(this.media.matches||document.hidden||!this.visible){this.writer?.stop();this.running=false;this.dataset.motionState=this.media.matches?'reduced':'paused';if(this.media.matches)this.dataset.typeReady='false';return;}
    if(!window.Typewriter||this.finished||this.running)return;
    if(!this.writer){
      let words;try{words=JSON.parse(this.dataset.words);}catch{return;}
      const visual=this.querySelector('[data-type-visual]');this.dataset.typeReady='false';visual.replaceChildren();
      this.writer=new window.Typewriter(visual,{loop:false,delay:65,deleteSpeed:30,skipAddStyles:true});
      words.forEach((word,index)=>{const escaped=String(word).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));this.writer.typeString(escaped).pauseFor(300);if(index<words.length-1)this.writer.deleteAll(30);});
      this.writer.callFunction(()=>{this.finished=true;this.running=false;this.dataset.motionState='complete';});
    }
    this.dataset.typeReady='true';this.dataset.motionState='running';this.running=true;this.writer.start();
  }
  disconnect(){this.abort?.abort();this.observer?.disconnect();this.writer?.stop();this.writer=null;this.dataset.typeReady='false';this.querySelector('[data-type-visual]')?.replaceChildren();this.visible=false;this.running=false;this.finished=false;this.dataset.motionState='static';}
  disconnectedCallback(){this.disconnect();}
});
  } catch(e) { console.error(e); }
})();

})();
